export default __webpack_public_path__ + "static/media/Copyright.05ffc828.txt";